import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { routes } from '@/constants';
import { useResidency } from '@/hooks/useResidency';

/**
 * Keeps the recording pages closed until the candidate has declared they do
 * not live in California or Illinois. A stored `ca_il` also redirects — the
 * gate then renders its block screen.
 */
export default function RequireResidency({ children }: PropsWithChildren) {
  const { answer } = useResidency();
  const { search } = useLocation();

  if (answer !== 'other') {
    return <Navigate to={routes.residency + search} replace />;
  }

  return <>{children}</>;
}
